import axios from '../utils/axios'

export const getPrices = async () => {
  try {
    const result = await axios.get(`/api/prices`)
    return result?.data?.data || []
  } catch (err) {
    console.error(err)
    return []
  }
}

export const getPurchaseSecret = async (price) => {
  try {
    const result = await axios.post(`/api/pay`, { price_id: price })
    return result?.data
  } catch (err) {
    alert('Something went wrong')
  }
}
